define.alias("shared/components/shared/social/refresh-profile/twitter", "settings/components/shared/social/refresh-profile/twitter");